import Supercluster from 'supercluster';
import { WebMercatorViewport } from '@deck.gl/core';
import { MapMarkerType } from '../../../../../store/mst/models';
import { rankTransformClusteredData } from './zIndexHelpers';

export function buildClusterIndex(data: MapMarkerType[]) {
  const index = new Supercluster({
    radius: 150, // pixel radius tolerance to form a cluster
  });
  return index.load(data);
}

export function clusterDataAtSameLocation(
  enableClustersAtSameLocation: boolean,
  index: Supercluster,
  z: number,
) {
  const rankedAndScaledData = rankTransformClusteredData(index, z);

  if (!enableClustersAtSameLocation) {
    // If clustering is disabled, return the ranked data directly
    return rankedAndScaledData;
  }

  const clusteredAtSameLocation = new Supercluster({
    radius: 0,
    reduce: (acc: any, cur: any) => {
      acc.itemsSequence = [...(acc.itemsSequence || [acc.sequence]), cur.sequence];
      acc.itemsIds = [...(acc.itemsIds || [acc.id]), cur.id];
      acc.status = acc.status === cur.status ? cur.status : undefined; // Same status only
      delete acc.id; // Clustered marker should not have individual stop ID
    },
  });

  clusteredAtSameLocation.load(rankedAndScaledData);
  return clusteredAtSameLocation.getClusters([-180, -90, 180, 90], z);
}

export function getViewportBounds(viewport: WebMercatorViewport): [number, number, number, number] {
  const [minLng, minLat] = viewport.unproject([0, viewport.height]);
  const [maxLng, maxLat] = viewport.unproject([viewport.width, 0]);
  return [minLng, minLat, maxLng, maxLat];
}
